import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { CheckCircle, ArrowRightCircle } from "react-feather"; // Importing Feather icons
import "./WhoIsMyrtle.css";
import img1 from "../Assets/WhoandWhy/1_Predictable Outcome based Delivery.jpg";
import img2 from "../Assets/WhoandWhy/2_Flexible Pricing (1) (1).png";
import img3 from "../Assets/WhoandWhy/3_Strategic Partnership.jpg";
import img4 from "../Assets/WhoandWhy/4_COMPLIANCE.png";
import img5 from "../Assets/WhoandWhy/5_HUMAN CAPITAL.jpg";
import img6 from "../Assets/WhoandWhy/6_Geographical locations.jpg";

const data = [
  {
    title: "Predictable outcome delivery model",
    points: [
      "With a robust workflow, quality and other management systems in place and intervened by qualified expert team, we are confident and know what we deliver has",
      "5-10% documentation error reduction ↓",
      "5-10% eligibility denials reduction ↓",
      "20 -25% average reduction in AR days ↓",
      ">95% Coding accuracy ↑",
      " and hence an overall 10% steady increase in the collection rates ↑",
    ],
    image: img1,
  },
  {
    title: "Metrics driven Flexible Pricing Structure",
    points: [
      "As we understand the sensitivity of the patient information we process and deliver, our pricing model has uncompromised key metrics aligned to the interests of our clients.",
      "Some of the KPI's to quote here are Charge lag, GCR%, payments, NCR%, 120+AR%, Denials%, Insurance AR days, documentation deficiency %, coding accuracy, enables us to be transparent of our capabilities with our clients & also provides opportunity to identify & prevent revenue leakage at the earliest.",
      "Our financial system adapts swiftly to any pricing model, be it % of collections, Transaction pricing, or FTE pricing that suits our client.",
    ],
    image: img2,
  },
  {
    title: "Impactful Onshore Strategic Partnership",
    points: [
      "A well augmented onshore strategic partnership with 'RCM SUMMIT.COM' has enabled us to leverage a plethora of tools that seamlessly drives every aspect of our operations.",
      "Ensuring efficiency and precision at every stage—from talent acquisition to final client delivery. This robust system guarantees that every process is optimized, secure, and data-driven.",
      "By leveraging predictive analytics, we enhance our ability to forecast trends, anticipate challenges, and deliver results with unparalleled accuracy.",
      "Our decision-making processes are faster, more strategic, and allow us to provide our clients with cutting-edge solutions.",
    ],
    image: img3,
  },
  {
    title: "100% Compliance adherence - HL7 to FHIR Standards",
    points: [
      "As the healthcare data exchange evolves from the basic HL7 interoperability standards, our vibrant IT & compliance management system is flexible to both HL7 and the current FHIR (Fast Healthcare Interoperability Resources).",
      "The web-based approach ensures seamless communication between different healthcare applications. Our dedicated compliance team ensures that OIG protocols are adhered to ensure ZERO DATA LEAKAGE.",
    ],
    image: img4,
  },
  {
    title: "Empowered and skilled Human Capital",
    points: [
      "By investing in a well-structured HR & Training ecosystem, we create a workforce that is not only skilled but also deeply aligned with the company’s vision.",
      "HR policies provide ongoing support, fostering an inclusive and engaging work environment to enhance employee satisfaction and retention.",
      "Regular workshops, upskilling programs, and personalized career growth plans ensure employees stay relevant and competitive.",
    ],
    image: img5,
  },
  {
    title: "Geographically & demographically well-positioned work locations",
    points: [
      "Headquartered in the coastal city of Pondicherry, South India—an erstwhile French colony—we have established a strong presence in Hyderabad, a major metropolitan hub in Central India.",
      "Expanding our global footprint, we have partnered with RCM SUMMIT.COM, marking our presence in Grass Valley, California.",
      "Additionally, we are a registered LLC in Dover, Delaware, and are in the process of building a robust salesforce to drive our growth from this strategic location.",
    ],
    image: img6,
  },
];

const WhoIsMyrtle = () => {
  return (
    <Container fluid className="services-container">
      <Row className="text-center services-header">
        {/* <p className="services-subtitle mt-5"></p> */}
      </Row>

      {data.map((service, index) => (
        <div className="container mt-5" key={index}>
          <Row
            className={`services-content ${
              index % 2 === 0 ? "reverse" : ""
            } mb-5`}
          >
            <Col
              lg={6}
              className="services-image-container"
              style={{ marginTop: "20px" }}
            >
              <img
                src={service.image}
                alt={service.title}
                className="services-image"
              />
            </Col>
            <Col lg={6} className="services-text">
              <h3 className="services-heading">{service.title}</h3>
              <p className="services-description">{service.description}</p>
              <div className="services-list">
                {service.points.map((point, i) => (
                  <p key={i}>
                    <i className="fa fa-check-circle services-icon" />
                    {point}
                  </p>
                ))}
              </div>
            </Col>
          </Row>
        </div>
      ))}
    </Container>
  );
};

export default WhoIsMyrtle;
